var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductGroupPaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - Product Group Paging button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element-Catalogue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.899999976
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-39.000000, -174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon---Product-Group-Paging-button",
    transform: "translate(43.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Path",
    stroke: "#CFCFCF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    cx: 20.7982563,
    cy: 20.7982563,
    r: 20.3871343
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9199219,26.7675781 L23.1035156,28.5839844 L15.3535156,20.8339844 L23.1035156,13.0839844 L24.9199219,14.9003906 L18.9863281,20.8339844 L24.9199219,26.7675781 Z",
    id: "keyboard-arrow-left---MaterialIcons-Regular",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGroupPaging);
export default __webpack_public_path__ + "static/media/product-group-paging.dc233bcb48faec985ae658719a4ffcee.svg";
export { ForwardRef as ReactComponent };